import { observer } from 'mobx-react-lite'
import { FullPageWrapper } from 'shared/ui'
import { useBroadcastPageContext } from 'pages/broadcasts/context/broadcastsPageContext'
import { BroadcastList } from 'pages/broadcasts/ui/BroacastList'

export const RecurringBroadcastsPage = observer(() => {
  const storeBroadcastPage = useBroadcastPageContext()

  return (
    <FullPageWrapper>
      <BroadcastList
        storeProps={{ type: 'recurring', pageLayoutStore: storeBroadcastPage.pageLayoutStore }}
      />
    </FullPageWrapper>
  )
})
